import React, { useState, useEffect, useMemo } from 'react';
import Moment from 'moment';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import { CardHeader, Row, Col, Collapse, FormGroup, Label, Input, Button, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, Table, Modal, Form, ModalHeader, ModalBody, ModalFooter, Spinner, Badge } from 'reactstrap';
import { FaChevronRight, FaChevronUp, FaPlus, FaChevronLeft, FaChevronDown } from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import uuid from 'react-uuid';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Action from '../Action/Action';
import Documents from '../Uploads/Documents';
import ActionsToConsider from '../FarmApt/ActionsToConsider';
import { useNavigate, useLocation } from "react-router-dom";
import MapView from '../Map/MapView';
import ItemTypeListView from '../ItemsView/ItemTypeListView';
import MapType from '../ItemPopup/MapType';
import Validate from '../Validate/Validate';
import NutrientsItemView from './NutrientsItemView';
import RiskSummary from '../ItemsView/RiskSummary';
import moment from "moment";
import { useSearchParams } from 'react-router-dom';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { convertToRaw, EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import HistoricalActions from '../ItemsView/HistoricalActions';
import ItemTypeListViewForMap from '../ItemsView/ItemTypeListViewForMap';

const Nutrients = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {
    const roleName = localStorage.getItem("roleName"); const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    const [show_HistoricalActions, setShow_HistoricalActions] = useState(false);
    const [show_SectionComment, setShow_SectionComment] = useState(false); const [toggleSwitch, setToggleSwitch] = useState('map & details');
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const isAddEditItem = localStorage.getItem("isAddEditItem");
    const isCreateNewAction = localStorage.getItem("isCreateNewAction");
    const { state } = useLocation();
    const navigate = useNavigate();
    const [saving, setSaving] = useState('');
    const [itemDeletesaving, setItemDeleteSaving] = useState('');
    const [loading, setLoading] = useState(true); const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId")); const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [nutrients, setNutrients] = useState({
        outlineList: [], itemList: [], itemTypes: [], mapItemTypes: [], Section: 'Nutrients', SectionName: 'Nutrients', SectionObj: {}, isWizardCompleted: false, farmCenter: {},
        actionTypes: [], contaminants: [], goodFarmingPractices: [], goodFarmingPracticeGroups: [], actions: [], seasonList: [], nutrientOLSENPList: [], sectionComment: ''
    });
    const [largeEnterpriseDetails, setLargeEnterpriseDetails] = useState({ isLargeEnterprise: false, LMUList: [], selectedLMUId: 0 })
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: false, isLMUPage: false, isCenterReq: false, isFarmCenterEditable: false,
        isFarmOutlineEditable: false, zoomLevel: 15, polytype: '', itemsEditable: false, highlighteditemId: 0,isClear: false
    });
    const [showActionPopup, setShowActionPopup] = useState(false);const [type, setType] = useState(0);const [name, setName] = useState('');const [actionType, setActionType] = useState(0);
    const [id, setId] = useState(0); const [activeTab, setActiveTab] = useState('3'); const [nutrientSeasonList, setNutrientSeasonList] = useState([]); const [sectionObj, setSectionObj] = useState({});
    const [seasonData, setSeasonData] = useState(
        {
            CurrentSeason: {season:"",systemDetail:'', nitrogen_Total_loss: null, phosphorous_Total_loss: null, nitrogen_Load_loss: null, phosphorous_Load_loss: null, nitrogen_Conversion_Efficiency_Per: null, n_Purchased_Surplus: null },
            CurrentSeasonMinus1: { season: "", systemDetail: '', nitrogen_Total_loss: null, phosphorous_Total_loss: null, nitrogen_Load_loss: null, phosphorous_Load_loss: null, nitrogen_Conversion_Efficiency_Per: null, n_Purchased_Surplus: null },
            CurrentSeasonMinus2: { season: "", systemDetail: '', nitrogen_Total_loss: null, phosphorous_Total_loss: null, nitrogen_Load_loss: null, phosphorous_Load_loss: null, nitrogen_Conversion_Efficiency_Per: null, n_Purchased_Surplus: null }
        });
    const [closedActionCount, setClosedActionCount] = useState(0); const [openActionCount, setOpenActionCount] = useState(0); const [isClosedActionShow, setIsClosedActionShow] = useState(false);
    const [nutrientOLSENPList, setNutrientOLSENPList] = useState([]);
    const [toggleItemTypeListState, setToggleItemTypeListState] = useState({ isOpen: true, isIconUp: true });
    const [nutrientPopup, setNutrientPopup] = useState({
        showNutrientPopup: false, mapitem: [], farmId: farmId, id: 0, markertype: '', perimeter: 0.0, coordinates: '', Name: '', color: "#21b546", Description: '', LMUId: 0, optimalRange: '', olsenpValueRange: '',
        date:null,dateText:''
    });
    const [nutrientPopupMaptype, setNutrientPopupMaptype] = useState({ markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', });
    const [nutrientDeletePopup, setNutrientDeletePopup] = useState({ showNutrientDeletePopup: false, id: 0 });
    const [typeid, setTypeId] = useState(0); const [itemPopupItemField, setItemPopupItemField] = useState({
        itemTypeId: 0
    });
    const [LMUParentList, setLMUParentList] = useState([]);
    let selectedLMUId = largeEnterpriseDetails != null ? largeEnterpriseDetails.selectedLMUId : 0;
    let selectedLMU = nutrientPopup.LMUId != null ? nutrientPopup.LMUId : selectedLMUId;
    let lmustyle = selectedLMUId > 0 && childCount == 0 && selectedLMUId == selectedLMU ? true : false
    const [childCount, setchildCount] = useState(0);
    const [nutrientHeader, setNutrientHeader] = useState({id:0,
        farmId: localStorage.getItem("defaultFarmId"), chkFertiliserApplications: false, chkYearlyApplication: false, chkNitrogenLeaching: false,
        chkFertiliserApplicationsComment: "", chkYearlyApplicationComment: "", chkNitrogenLeachingComment:""
    });
    const [savingNutrientDetails, setSavingNutrientDetails] = useState(''); const [savingNutrientManagement, setSavingNutrientManagement] = useState('');
    const [riskSummaryPopup, setRiskSummaryPopup] = useState({ showriskSummary: false }); const [searchParams, setSearchParams] = useSearchParams();
    const [nutrientManagement, setNutrientManagement] = useState({ WhoCompletesSoilTest: '', HowOftenSoilIsTested: '', WhichPaddocksAreDoneAndWhen: '', WhoIsSpreadingFertiliser: '', WhatMethodUsedForProofOfPlacement :''});

    useEffect(() => {
        setLoading(true);
        populateItemData();
    }, []);
    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const populateItemData = async () => {
        try {
            const response = await axios.get(
                '/api/nutrients/GetNutrients/', {
                params: { farmId: farmId }
            }
            );
            if (response.data.status) {
                setLoading(false);
                if (response.data.section != null) {
                    var section = window.wizardDetails.filter(x => x.controllerName == response.data.section.routePath);
                    if (section.length > 0) {
                        setIsNextButtonVisible(section[0].isSectionCompleted);
                    }
                }
                setNutrients({
                    ...nutrients, outlineList: response.data.content.outlineList, itemList: response.data.content.nutrientItems, itemTypes: response.data.content.itemTypes,
                    mapItemTypes: response.data.content.mapItemTypes, SectionObj: response.data.content.section, isWizardCompleted: response.data.content.isFWFPCompleted, farmCenter: response.data.content.farmCenter,
                    actionTypes: response.data.content.actionTypes, contaminants: response.data.content.contaminants, goodFarmingPractices: response.data.content.goodFarmingPractices,
                    goodFarmingPracticeGroups: response.data.content.goodFarmingPracticeGroups, actions: response.data.content.actions, sectionComment: response.data.content.sectionComment
                });
                const content = ContentState.createFromBlockArray(convertFromHTML(response.data.content.sectionComment == null ? '' : response.data.content.sectionComment))
                setEditorState(EditorState.createWithContent(content));
                setNutrientHeader({
                    ...nutrientHeader, id: response.data.content.nutrientHeader.id, chkFertiliserApplications: response.data.content.nutrientHeader.chkFertiliserApplications, chkYearlyApplication: response.data.content.nutrientHeader.chkYearlyApplication,
                    chkNitrogenLeaching: response.data.content.nutrientHeader.chkNitrogenLeaching, chkFertiliserApplicationsComment: response.data.content.nutrientHeader.chkFertiliserApplicationsComment,
                    chkYearlyApplicationComment: response.data.content.nutrientHeader.chkYearlyApplicationComment, chkNitrogenLeachingComment: response.data.content.nutrientHeader.chkNitrogenLeachingComment,
                })
                setNutrientManagement({
                    ...nutrientManagement, WhoCompletesSoilTest: response.data.content.whoCompletesSoilTest, HowOftenSoilIsTested: response.data.content.howOftenSoilIsTested
                    , WhichPaddocksAreDoneAndWhen: response.data.content.whichPaddocksAreDoneAndWhen, WhoIsSpreadingFertiliser: response.data.content.whoIsSpreadingFertiliser
                    , WhatMethodUsedForProofOfPlacement: response.data.content.whatMethodUsedForProofOfPlacement
                })
                setMapDetails({ ...mapDetails, zoomLevel: response.data.content.selectedZoomlevel });
                setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isLargeEnterprise: response.data.content.islargeEnterprise, LMUList: response.data.content.lmuItemList })
                setNutrientSeasonList(response.data.content.seasonList);
                setSeasonData({
                    ...seasonData,
                    CurrentSeason: response.data.content.currentSeason
                    , CurrentSeasonMinus1: response.data.content.currentSeasonMinus1, CurrentSeasonMinus2: response.data.content.currentSeasonMinus2
                });
                setOpenActionCount(response.data.content.actions.filter(action => action.isCloseout != true).length);
                setShow_HistoricalActions(response.data.content.show_HistoricalActions);
                setShow_SectionComment(response.data.content.show_SectionComment);
                setClosedActionCount(response.data.content.actions.filter(action => action.isCloseout == true).length);
                setNutrientOLSENPList(response.data.content.nutrientOLSENPList);
                setSectionObj(response.data.content.section);
                if (state != null) {
                    const { itemId, actionId, navigateFrom } = state;
                    navigate(state.pathname, { replace: true });
                    if (navigateFrom == "Actions") {
                        handleNavigateOpenActionPopup(itemId, actionId, response.data.content);
                    }
                }
                let search = window.location.search;
                let params = new URLSearchParams(search);
                let navigateFrom = params.get('navigateFrom');
                if (navigateFrom == 'Actions') {
                    let actionId = params.get('actionId');
                    let itemId = params.get('itemId');
                    let isWholeFarmAction = params.get('isWholeFarmAction');
                    if (searchParams.has('actionId')) {
                        searchParams.delete('actionId');
                        setSearchParams(searchParams);
                    }
                    if (searchParams.has('itemId')) {
                        searchParams.delete('itemId');
                        setSearchParams(searchParams);
                    }
                    if (searchParams.has('isWholeFarmAction')) {
                        searchParams.delete('isWholeFarmAction');
                        setSearchParams(searchParams);
                    }
                    if (searchParams.has('navigateFrom')) {
                        searchParams.delete('navigateFrom');
                        setSearchParams(searchParams);
                    }
                    if (navigateFrom == "Actions") {
                        handleNavigateOpenActionPopup(itemId, actionId, response.data.content);
                    }
                }
            }
            
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
        }
    }

    const handleNavigateOpenActionPopup = (itemId, actionId, ghg) => {
        setShowActionPopup(true);
        setId(actionId)
    };

    const handleOpenActionPopup = async (e) => {
        setShowActionPopup(true);
        setId(0)
    };

    const handleOpenAction = async (e, item) => {
        setShowActionPopup(true);
        setId(item.id)
    };

    function handleActionClose() {
        setShowActionPopup(false);
    }

    function handleClosedActionShow(event) {
        setIsClosedActionShow(event.target.checked);
    }

    const addMapItem = (mapItem, mapType) => {
        let path, area = 0.0, perimeter = 0.0, coordinates = '';
        var selectedItemType = nutrients.mapItemTypes.filter(item => item.id == typeid)[0];
        const ItemTypeName = selectedItemType.name;
        var LMUParentListTemp = largeEnterpriseDetails.selectedLMUId > 0 ? largeEnterpriseDetails.LMUList.filter(lmu => !lmu.isConnectedToAnotherLMU && lmu.id == largeEnterpriseDetails.selectedLMUId) :
            largeEnterpriseDetails.LMUList.filter(lmu => !lmu.isConnectedToAnotherLMU);
        setLMUParentList(LMUParentListTemp);
        var childCountTemp = largeEnterpriseDetails.LMUList.filter(child => child.lmuId == selectedLMU).length;
        setchildCount(childCountTemp)
        if (mapType == 'polyline') {
            path = mapItem.getPath();
            area = 0;
            perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            var PolygonCoords = "";
            path.getArray().map((pointCo) => {

                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            coordinates = PolygonCoords;
            if (path.getArray().length <= 1) {
                toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                resetValues();
                return false;
            }
        }
        setNutrientPopup({
            ...nutrientPopup, showNutrientPopup: true, mapitem: mapItem, farmId: farmId, id: 0, markertype: mapType, perimeter: perimeter, coordinates: coordinates,
            Name: '', color: '#21b546', Description: '', LMUId: 0, olsenpValueRange: '', optimalRange: '', date: null, dateText:''
        });
        setNutrientPopupMaptype({ ...nutrientPopupMaptype, markertype: mapType, area: area, perimeter: perimeter, coordinates: coordinates });
    }

    function handleItemEditPopup(itemId) {
        editMapItem([], itemId, false)
    }

    const editMapItem = (mapItem, itemId, isDragged) => {
        var nutrient = nutrients.itemList.filter(x => x.itemId == itemId)[0];
        let coordinates = nutrient.mapCoordinates;
        let area = 0.0, perimeter = 0.0;
        if (nutrient.mapMarkerType == "polyline") {
            const Coordinates = coordinates.split(':');
            const positions = [];
            Coordinates.filter(coor => coor != "").map((Coordinate) => {
                const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                positions.push(pos);
            })
            const tempPolyline = new window.google.maps.Polyline({
                paths: positions
            });
            let path = tempPolyline.paths;
            area = nutrient.area;
            perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            if (path.length <= 1) {
                toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                resetValues();
                return false;
            }
        }
        var LMUParentListTemp = largeEnterpriseDetails.selectedLMUId > 0 ? largeEnterpriseDetails.LMUList.filter(lmu => !lmu.isConnectedToAnotherLMU && lmu.id == largeEnterpriseDetails.selectedLMUId) :
            largeEnterpriseDetails.LMUList.filter(lmu => !lmu.isConnectedToAnotherLMU);
        setLMUParentList(LMUParentListTemp);
        var childCountTemp = largeEnterpriseDetails.LMUList.filter(child => child.lmuId == nutrient.lmuId).length;
        setchildCount(childCountTemp);
        var Date = null;
        var DateText = '';
        if (nutrient.date != null) {
            Date = getDateFromString(moment(nutrient.date).format("DD/MM/YYYY")) ;
            DateText = getParsedDate(Date);
        }
        setNutrientPopup({
            ...nutrientPopup, showNutrientPopup: true, mapitem: mapItem, farmId: farmId, id: itemId, markertype: nutrient.mapMarkerType, perimeter: perimeter, coordinates: coordinates,
            Name: nutrient.name, color: nutrient.colour, Description: nutrient.description, LMUId: nutrient.lmuId, olsenpValueRange: nutrient.olsenpValueRange,
            optimalRange: nutrient.optimalRange, date: Date, dateText: DateText
        });
        setNutrientPopupMaptype({ ...nutrientPopupMaptype, markertype: nutrient.mapMarkerType, area: area, perimeter: perimeter, coordinates: coordinates });
    }

    const getDateFromString = (date) => {
        var dd = date.split('/')[0];
        var mm = date.split('/')[1];
        var yyyy = date.split('/')[2];
        var newDate = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        return newDate;
    }

    const getParsedDate = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "/" + mm + "/" + yyyy;
        return date.toString();
    }

    function handleClearSelection() {
        setTypeId(0);
        setMapDetails({ ...mapDetails, polyType: '', isClear: true });
        setItemPopupItemField({ ...itemPopupItemField, itemTypeId: 0 });
        window.location.reload(true);
    }

    const handleItemClick = (event, typeid, polyType) => {
        setTypeId(typeid);
        setMapDetails({ ...mapDetails, polyType: polyType, isClear: false });
        setItemPopupItemField({ ...itemPopupItemField, itemTypeId: typeid });
    }

    const handleItemTypeListTogole = (isOpen, isIconUp) => {
        setToggleItemTypeListState({ ...toggleItemTypeListState, isOpen: isOpen, isIconUp: isIconUp })
    }

    const handleItemHighlight = (itemId) => {
        setMapDetails({ ...mapDetails, highlighteditemId: itemId })
    }

    function handleNutrientPopupClose() {
        resetValues();
    }

    function resetValues() {
        setNutrientPopup({
            ...nutrientPopup, showNutrientPopup: false, mapitem: [], farmId: farmId, id: 0, markertype: '', perimeter: 0.0, coordinates: '', Name: '', color: '#21b546', Description: '',
            LMUId: 0, olsenpValueRange: '', optimalRange:''
        });
        setNutrientDeletePopup({ showNutrientDeletePopup: false, id: 0 });
        setMapDetails({ ...mapDetails, isClear: true });
    }

    function handleNutrientItemsChange(event) {
        const { name, value, checked, type } = event.target;
        setNutrientPopup({ ...nutrientPopup, [name]: type == 'checkbox' ? checked : value });
    }

    function handleNutrientDeletePopup(id) {
        setNutrientDeletePopup({ showNutrientDeletePopup: true, id: id });
    }

    const handleNutrientSubmit = async (event) => {
        setSaving(true);
        let form = {
            Id: nutrientPopup.id,
            MapMarkerType: nutrientPopup.markertype,
            FarmId: nutrientPopup.farmId,
            Name: nutrientPopup.Name,
            Description: nutrientPopup.Description,
            Colour: nutrientPopup.color,
            Length: nutrientPopup.perimeter,
            MapCoordinates: nutrientPopup.coordinates,
            UserId: userId,
            LMUId: nutrientPopup.LMUId,
            OptimalRange: nutrientPopup.optimalRange,
            OLSENPValueRange: nutrientPopup.olsenpValueRange,
            Date: nutrientPopup.dateText
        }
        if (!Validate(form)) {
            try {
                const response = await axios.post(
                    '/api/nutrients/SaveNutrients/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    });
                if (response.data != null) {
                    await refreshItemDetails();
                    handleNutrientPopupClose();
                    setSaving(false);
                }
            } catch (error) {
                setSaving(false);
                console.error('Error:', error);
            }
        }
    }

    const refreshItemDetails = async () => {
        const response = await axios.get(
            '/api/nutrients/GetNutrients/', {
            params: { farmId: farmId }
        }
        );
        if (response.data.status) {
            setNutrients({
                ...nutrients,  itemList: response.data.content.nutrientItems
            });
        }
    }

    function handleItemDeletePopupClose() {
        setNutrientDeletePopup({ showNutrientDeletePopup: false, itemId: 0 });
    }

    const deleteItembyId = async (id) => {
        try {
            setItemDeleteSaving(true);
            const response = await axios.get(
                '/api/nutrients/DeleteNutrients/', {
                params: {
                        itemId: id, userId: userId
                }
            }
            );
            if (response.data != null) {
                await refreshItemDetails();
                handleNutrientPopupClose();
                setItemDeleteSaving(false);
            }
        } catch (error) {
            setItemDeleteSaving(false);
            console.error('Error:', error);
        }
    }

    const deleteItem = async (event) => {
        setItemDeleteSaving(true);
        const itemid = nutrientDeletePopup.id;
        try {
            const response = await axios.get(
                '/api/nutrients/DeleteNutrients/', {
                params: {
                    itemId: itemid, userId: userId
                }
            }
            );
            if (response.data != null) {
                await refreshItemDetails();
                handleNutrientPopupClose();
                setItemDeleteSaving(false);
            }
        } catch (error) {
            setItemDeleteSaving(false);
            console.error('Error:', error);
        }
    }

    const seasonDataChange = async (event,object,variable) => {
        let tempSeasonData = seasonData;
        if (object == "CurrentSeason") {
            if (variable == "nitrogen_Total_loss") {
                tempSeasonData.CurrentSeason.nitrogen_Total_loss = parseFloat(event.target.value);
            }
            else if (variable == "systemDetail") {
                tempSeasonData.CurrentSeason.systemDetail = event.target.value;
            }
            else if (variable == "phosphorous_Total_loss") {
                tempSeasonData.CurrentSeason.phosphorous_Total_loss = parseFloat(event.target.value);
            }
            else if (variable == "nitrogen_Load_loss") {
                tempSeasonData.CurrentSeason.nitrogen_Load_loss = parseFloat(event.target.value);
            }
            else if (variable == "phosphorous_Load_loss") {
                tempSeasonData.CurrentSeason.phosphorous_Load_loss = parseFloat(event.target.value);
            }
            else if (variable == "nitrogen_Conversion_Efficiency_Per") {
                tempSeasonData.CurrentSeason.nitrogen_Conversion_Efficiency_Per = parseFloat(event.target.value);
            }
            else if (variable == "n_Purchased_Surplus") {
                tempSeasonData.CurrentSeason.n_Purchased_Surplus = parseFloat(event.target.value);
            }
        }
        else if (object == "CurrentSeasonMinus1") {
            if (variable == "nitrogen_Total_loss") {
                tempSeasonData.CurrentSeasonMinus1.nitrogen_Total_loss = parseFloat(event.target.value);
            }
            else if (variable == "systemDetail") {
                tempSeasonData.CurrentSeasonMinus1.systemDetail = event.target.value;
            }
            else if (variable == "phosphorous_Total_loss") {
                tempSeasonData.CurrentSeasonMinus1.phosphorous_Total_loss = parseFloat(event.target.value);
            }
            else if (variable == "nitrogen_Load_loss") {
                tempSeasonData.CurrentSeasonMinus1.nitrogen_Load_loss = parseFloat(event.target.value);
            }
            else if (variable == "phosphorous_Load_loss") {
                tempSeasonData.CurrentSeasonMinus1.phosphorous_Load_loss = parseFloat(event.target.value);
            }
            else if (variable == "nitrogen_Conversion_Efficiency_Per") {
                tempSeasonData.CurrentSeasonMinus1.nitrogen_Conversion_Efficiency_Per = parseFloat(event.target.value);
            }
            else if (variable == "n_Purchased_Surplus") {
                tempSeasonData.CurrentSeasonMinus1.n_Purchased_Surplus = parseFloat(event.target.value);
            }
        }
        else if (object == "CurrentSeasonMinus2") {
            if (variable == "nitrogen_Total_loss") {
                tempSeasonData.CurrentSeasonMinus2.nitrogen_Total_loss = parseFloat(event.target.value);
            }
            else if (variable == "systemDetail") {
                tempSeasonData.CurrentSeasonMinus2.systemDetail = event.target.value;
            }
            else if (variable == "phosphorous_Total_loss") {
                tempSeasonData.CurrentSeasonMinus2.phosphorous_Total_loss = parseFloat(event.target.value);
            }
            else if (variable == "nitrogen_Load_loss") {
                tempSeasonData.CurrentSeasonMinus2.nitrogen_Load_loss = parseFloat(event.target.value);
            }
            else if (variable == "phosphorous_Load_loss") {
                tempSeasonData.CurrentSeasonMinus2.phosphorous_Load_loss = parseFloat(event.target.value);
            }
            else if (variable == "nitrogen_Conversion_Efficiency_Per") {
                tempSeasonData.CurrentSeasonMinus2.nitrogen_Conversion_Efficiency_Per = parseFloat(event.target.value);
            }
            else if (variable == "n_Purchased_Surplus") {
                tempSeasonData.CurrentSeasonMinus2.n_Purchased_Surplus = parseFloat(event.target.value);
            }
        }
        setSeasonData({
            ...seasonData,
            CurrentSeason: tempSeasonData.CurrentSeason, CurrentSeasonMinus1: tempSeasonData.CurrentSeasonMinus1, CurrentSeasonMinus2: tempSeasonData.CurrentSeasonMinus2
        });
    }
    const handleNutrientManagementSubmit = async (e) => {
        e.preventDefault();
        setSavingNutrientManagement(true);
        let form = {
            FarmId: nutrientPopup.farmId,
            WhoCompletesSoilTest: nutrientManagement.WhoCompletesSoilTest,
            HowOftenSoilIsTested: nutrientManagement.HowOftenSoilIsTested,
            WhichPaddocksAreDoneAndWhen: nutrientManagement.WhichPaddocksAreDoneAndWhen,
            WhoIsSpreadingFertiliser: nutrientManagement.WhoIsSpreadingFertiliser,
            WhatMethodUsedForProofOfPlacement: nutrientManagement.WhatMethodUsedForProofOfPlacement,
        }

        try {
            const response = await axios.post(
                '/api/nutrients/SaveNutrientManagement/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response.data != null) {
                setSavingNutrientManagement(false);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };
    const handleNutrientDetailsSubmit = async (e) => {
        e.preventDefault();
        setSavingNutrientDetails(true);
        let form = {
            Id: nutrientHeader.id,
            FarmId: nutrientPopup.farmId,
            ChkFertiliserApplications: nutrientHeader.chkFertiliserApplications,
            ChkYearlyApplication: nutrientHeader.chkYearlyApplication,
            ChkNitrogenLeaching: nutrientHeader.chkNitrogenLeaching,
            ChkFertiliserApplicationsComment: nutrientHeader.chkFertiliserApplicationsComment,
            ChkYearlyApplicationComment: nutrientHeader.chkYearlyApplicationComment,
            ChkNitrogenLeachingComment: nutrientHeader.chkNitrogenLeachingComment,
            UserId: userId,
            CurrentSeason: seasonData.CurrentSeason,
            CurrentSeasonMinus1: seasonData.CurrentSeasonMinus1,
            CurrentSeasonMinus2: seasonData.CurrentSeasonMinus2
        }

        try {
            const response = await axios.post(
                '/api/nutrients/SaveNutrientDetails/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response.data != null) {
                setSavingNutrientDetails(false);
                setNutrientHeader({
                    ...nutrientHeader, id: response.data.content.id, chkFertiliserApplications: response.data.content.chkFertiliserApplications, chkYearlyApplication: response.data.content.chkYearlyApplication,
                    chkNitrogenLeaching: response.data.content.chkNitrogenLeaching, chkFertiliserApplicationsComment: response.data.content.chkFertiliserApplicationsComment,
                    chkYearlyApplicationComment: response.data.content.chkYearlyApplicationComment, chkNitrogenLeachingComment: response.data.content.chkNitrogenLeachingComment,
                });
                setSeasonData({
                    ...seasonData,CurrentSeason: response.data.content.currentSeason,CurrentSeasonMinus1: response.data.content.currentSeasonMinus1,CurrentSeasonMinus2: response.data.content.currentSeasonMinus2
                });
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleRiskSummaryClose = () => {
        setRiskSummaryPopup({ ...riskSummaryPopup, showriskSummary: false })
        window.location.reload(true);
    }

    const handleRiskSummaryOpen = () => {
        setRiskSummaryPopup({ ...riskSummaryPopup, showriskSummary: true })
    }

    const mapView = useMemo(() => {
        return (
            <MapView width={toggleSwitch == 'map' ? '80vw' : '50vw'}
                height={toggleSwitch == 'map' ? '80vw' : '50vw'}
                itemModel={nutrients}
                mapDetails={mapDetails}
                addMapItem={addMapItem}
                largeEnterpriseDetails={largeEnterpriseDetails}
                editMapItem={editMapItem}
            ></MapView>
        )
    }, [nutrients, mapDetails, largeEnterpriseDetails, toggleSwitch])

    const itemTypeListView = useMemo(() => {

        return (
            <ItemTypeListViewForMap isWizardCompleted={nutrients.isWizardCompleted} Section="Soil Test Strip"
                itemTypesList={nutrients.mapItemTypes}
                toggleItemTypeListState={toggleItemTypeListState}
                handleClearSelection={handleClearSelection}
                handleItemClick={handleItemClick}
                handleItemTypeListTogole={handleItemTypeListTogole}
            >
            </ItemTypeListViewForMap>
        )
    }, [nutrients, largeEnterpriseDetails, nutrients.SectionObj, toggleItemTypeListState, nutrients.outlineCenter])

    const nonMapView = useMemo(() => {
        return (
            <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                <Row>
                    <Col>
                        <>
                            <Row>
                                <Col>
                                    <Row>
                                        <Col>
                                            <h4>SOIL TEST STRIP </h4>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Label className="info-text">Click an icon and place it on the map to mark and manage soil test strip</Label>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </>
                        <hr />
                        <ItemTypeListView Section="Soil Test Strip"
                            itemTypesList={nutrients.mapItemTypes}
                            toggleItemTypeListState={toggleItemTypeListState}
                            handleClearSelection={handleClearSelection}
                            handleItemClick={handleItemClick}
                            handleItemTypeListTogole={handleItemTypeListTogole}
                        >
                        </ItemTypeListView>
                    </Col>
                </Row>
                {nutrients.itemList != undefined && nutrients.itemList != null && nutrients.itemList.map((item, idx) => (
                    <NutrientsItemView key={uuid()} handleNutrientDeletePopup={handleNutrientDeletePopup} handleItemEditPopup={handleItemEditPopup} nutrientsItem={item} handleItemHighlight={handleItemHighlight}></NutrientsItemView>
                ))}
            </div>
        )
    }, [nutrients, toggleItemTypeListState])

    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen);
        setIsIconUp(!isIconUp);
    };

    const [soilTestIsOpen, setSoilTestIsOpen] = useState(false);
    const [soilTestIsIconUp, setSoilTestIsIconUp] = useState(false);
    const soilTestToggle = () => {
        setSoilTestIsOpen(!soilTestIsOpen);
        setSoilTestIsIconUp(!soilTestIsIconUp);
    };

    const handleSectionCommentChange = (e) => {
        const { name, value, checked, type } = e.target;
        setNutrients({ ...nutrients, sectionComment: value })
    }

    const handlePageChange = async (section, method) => {
        await SaveSectionComment();
        if (method == 'handleWizardChanged') {
            handleWizardChanged(section);
        }
        else if (method == 'handleMoveToNextPage') {
            handleMoveToNextPage(section);
        }
        else if (method == 'handleWizardChangedBack') {
            handleWizardChangedBack(section);
        }
    }
    const [savingSectionComment, setSavingSectionComment] = useState('');
    const saveSectionComment = async () => {
        setSavingSectionComment(true);
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await axios.post(
                '/api/nutrients/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response) {
                setSavingSectionComment(false);
            }
        } catch (err) {
            console.log(err);
            setSavingSectionComment(false);
        }
    }
    const SaveSectionComment = async () => {
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await axios.post(
                '/api/nutrients/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
        } catch (err) {
            console.log(err);
        }
    }

    const CustomToastWithLink = () => (
        <div>
            <p>The first form is where you can select, from a drop-down, what risk or risks the action will be mitigating. After you’ve selected the risk, a secondary form will open, and you can complete what land units this action will take place on. In addition, you can choose from a drop-down of possible actions to mitigate this risk. When you’ve chosen an action click on select and you’ll be taken back to the primary form. It will now show your selections and you can complete the additional information and “Save.”</p>
        </div>
    );
    const customId = "custom-id-yes1";
    const showToastMessage = (e) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };

    function handleInputChange(event) {
        const { name, value, checked, type } = event.target;
        setNutrientManagement({ ...nutrientManagement, [name]: type == 'checkbox' ? checked : value });
    }

    const toggleSwitchChange = (e) => {
        setToggleSwitch(e)
        if (e == 'map') {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'none';
            document.getElementById('itemTypeListView').style.height = '70vh';
        }
        else if (e == 'details') {
            document.getElementById('mapView').style.display = 'none';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
        else {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
    }

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">{nutrients.SectionName}</h3></Col>
                <Col>
                    {!loading &&
                        <>
                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                            <>
                            <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(nutrients.Section,'handleWizardChanged')}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        {roleName != 'Admin' && saveRightsForNonItemFieldsAndTables == 'false' && isNextButtonVisible &&
                            <>
                            <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(nutrients.Section,'handleMoveToNextPage')}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(nutrients.Section,'handleWizardChangedBack')}>Back <FaChevronLeft /> </Button>
                        </>
                    }
                </Col>
                
            </Row>
            <br />
            {loading ? <SpinnerContainer /> :
                <Row style={{ marginTop: '10px' }}>
                    {/*<Col>*/}
                    {/*    <Card className="my-4">*/}
                    {/*        <CardBody>*/}
                    {/*            <Row>*/}
                    {/*                <Col sm="12">*/}
                    {/*                    {mapView}*/}
                    {/*                </Col>*/}
                    {/*            </Row>*/}
                                
                    {/*        </CardBody>*/}
                    {/*    </Card>*/}
                        
                    {/*</Col>*/}
                    <Col id='mapView'>
                        <Row className="map-layer">
                            <Col>
                                <Row>
                                    <Col sm="3"> {toggleSwitch == 'map & details' &&
                                        <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map')}>Full Map&nbsp;&nbsp;
                                            <img src="/images/button-details_expand.png" className="card_icon" ></img>
                                        </Button>
                                    }
                                        {toggleSwitch == 'map' &&
                                            <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Map&nbsp;&nbsp;
                                                <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                                {mapView}
                            </Col>
                        </Row>

                    </Col>
                    <Col id="itemTypeListView" style={{ display: toggleSwitch == 'map' ? 'block' : 'none', height: "70vh", overflowY: "scroll", width: "20vw" }}>
                        <br />
                         <Row>
                             <Col>
                                 <h4>SOIL TEST STRIP </h4>
                             </Col>
                         </Row>
                         <Row>
                             <Col>
                                 <Label className="info-text">Click an icon and place it on the map to mark and manage soil test strip</Label>
                             </Col>
                         </Row>
                        <hr />
                        {itemTypeListView}
                        <br />
                    </Col>
                    <Col id='nonMapView' style={{ width: "50vw", display: toggleSwitch == 'map' ? 'none' : 'block', marginTop: "-25px" }}>
                        <Row>
                            <Col style={{ borderBottom: "1px solid #0d535d" }}>
                                {toggleSwitch == 'map & details' &&
                                    <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#0d535d" }} className="btn btnExpandContract" onClick={(e) => toggleSwitchChange('details')}>Full Details&nbsp;&nbsp;
                                        <img src="/images/button-details_expand.png" style={{}} className="card_icon" ></img>
                                    </Button>
                                }
                                {toggleSwitch == 'details' &&
                                    <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#0d535d" }} className="btn btnExpandContract" onClick={(e) => toggleSwitchChange('map & details')}>Small Details&nbsp;&nbsp;
                                        <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                    </Button>
                                }
                                {
                                    !loading && <Button style={{ marginLeft: "0.5vw" }} onClick={() => handleRiskSummaryOpen()} className="btn btn-risk-summary">Risk and Actions summary</Button>
                                }
                            </Col>
                        </Row>
                        {show_SectionComment &&  
                            <Row>
                                <Col sm="12">
                                    <FormGroup>
                                        <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "16px" }}><b>Section Comment</b> <span className="text-lowercase">(add any information around the features, actions, or risks, that have been considered on this page)</span></Label>
                                        <Editor handlePastedText={() => false}
                                            defaultEditorState={editorState}
                                            onEditorStateChange={setEditorState}
                                            wrapperClassName="wrapper-class"
                                            editorClassName="editor-class"
                                            toolbarClassName="toolbar-class"
                                            toolbar={
                                                {
                                                    options: ['inline'], inline: {
                                                        inDropdown: false,
                                                        options: ['bold', 'italic', 'underline'],
                                                    }
                                                }
                                            }
                                        />
                                    </FormGroup>

                                </Col>
                                <Col sm="12">
                                    {savingSectionComment ?
                                        <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" disabled>
                                            <Row>
                                                <Col sm="8">
                                                    <span>
                                                        {' '}Saving
                                                    </span>
                                                </Col>
                                                <Col sm="4">
                                                    <Spinner size="sm">
                                                        Saving...
                                                    </Spinner>
                                                </Col>
                                            </Row>
                                        </Button>
                                        :
                                        <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" size="sm">
                                            Save
                                        </Button>
                                    }
                                </Col>
                            </Row>    
                        }
                        <Card className="my-4">
                            <CardBody>
                                
                                <Row>
                                    <Col sm="12">
                                        {nonMapView}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card className="my-4">
                            <CardHeader className="card-header-click" onClick={soilTestToggle}>
                                <Row>
                                    <Col sm="11">
                                        <h5>Soil Tests and Fertiliser
                                        </h5>
                                    </Col>
                                    <Col sm="1" className="toggleoutline_lt">{setSoilTestIsIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                </Row>
                            </CardHeader>
                            <Collapse isOpen={soilTestIsOpen}>
                                <CardBody>
                                    <Row>
                                        <Col sm="6">
                                            <Label className="text-capitalize">Who completes the soil tests</Label>
                                        </Col>
                                        <Col sm="6">
                                            <Input type="text" name="WhoCompletesSoilTest" id="WhoCompletesSoilTest" value={nutrientManagement.WhoCompletesSoilTest}
                                                onChange={handleInputChange} />
                                        </Col>
                                    </Row>
                                    <Row style={{marginTop:"10px"}}>
                                        <Col sm="6">
                                            <Label className="text-capitalize">How often the soil is tested</Label>
                                        </Col>
                                        <Col sm="6">
                                            <Input type="text" name="HowOftenSoilIsTested" id="HowOftenSoilIsTested" value={nutrientManagement.HowOftenSoilIsTested}
                                                onChange={handleInputChange} />
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: "10px" }}>
                                        <Col sm="6">
                                            <Label className="text-capitalize">Which paddocks were done and when</Label>
                                        </Col>
                                        <Col sm="6">
                                            <Input type="text" name="WhichPaddocksAreDoneAndWhen" id="WhichPaddocksAreDoneAndWhen" value={nutrientManagement.WhichPaddocksAreDoneAndWhen}
                                                onChange={handleInputChange} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="12">
                                            <span className="smart-list" style={{ fontSize: "15px", fontWeight: "700" }}>
                                                Fertiliser
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: "10px" }}>
                                        <Col sm="6">
                                            <Label className="text-capitalize">Who is spreading it</Label>
                                        </Col>
                                        <Col sm="6">
                                            <Input type="text" name="WhoIsSpreadingFertiliser" id="WhoIsSpreadingFertiliser" value={nutrientManagement.WhoIsSpreadingFertiliser}
                                                onChange={handleInputChange} />
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: "10px" }}>
                                        <Col sm="6">
                                            <Label className="text-capitalize">What method used for proof of placement</Label>
                                        </Col>
                                        <Col sm="6">
                                            <Input type="text" name="WhatMethodUsedForProofOfPlacement" id="WhatMethodUsedForProofOfPlacement" value={nutrientManagement.WhatMethodUsedForProofOfPlacement}
                                                onChange={handleInputChange} />
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: "10px" }}>
                                        <Col sm="12">
                                            {savingNutrientManagement ?
                                                <Button style={{ float: "right" }} onClick={handleNutrientManagementSubmit}
                                                    color="success"
                                                    disabled
                                                >
                                                    <Row>
                                                        <Col sm="8">
                                                            <span>
                                                                {' '}Saving
                                                            </span>
                                                        </Col>
                                                        <Col sm="4">
                                                            <Spinner size="sm">
                                                                Saving...
                                                            </Spinner>
                                                        </Col>
                                                    </Row>
                                                </Button>
                                                :
                                                <Button style={{ float: "right" }} onClick={handleNutrientManagementSubmit} color="success" size="sm">
                                                    Save
                                                </Button>
                                            }
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Collapse>
                        </Card>
                        <Card className="my-4">
                            <CardHeader className="card-header-click" onClick={toggle}>
                                <Row>
                                    <Col sm="11">
                                        <h5>Actions{openActionCount > 0 ?
                                            <span className="risk-badge">
                                                | <Badge color="primary">
                                                    {openActionCount}
                                                </Badge> <span className="card-header-label-xs">Open Action(s)</span>
                                            </span> :
                                            <></>}&nbsp;&nbsp;&nbsp;
                                            <img className="featureIcon" src="/images/info_button_dk.png" data-tooltip-id="my-tooltip-31" onClick={(e) => e.stopPropagation()} />
                                        </h5>
                                        <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                            id="my-tooltip-31"
                                            place="top"
                                            variant="info"
                                            render={({ content, activeAnchor }) => (
                                                <>
                                                    <Row>
                                                        <Col>
                                                            <p style={{ fontWeight: "lighter" }}>
                                                                For more information on how to create and close actions <a href="https://freshwaterfarmplan.co.nz/support-category/actions/" target="_blank" rel="noreferrer">Click Here</a>
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                        />
                                    </Col>
                                    <Col sm="1" className="toggleoutline_lt">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                </Row>
                            </CardHeader>
                            <Collapse isOpen={isOpen}>
                                <CardBody>
                                    <Row>
                                        <Col sm="8">
                                        </Col>
                                        <Col sm="4">
                                            {(roleName == 'Admin' || isCreateNewAction == 'true') &&
                                                <>
                                            <Button className="btn-items-actions" color="success" size="sm" onClick={handleOpenActionPopup} >
                                                <FaPlus /> Action
                                                </Button>
                                                </>
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="12">
                                            <table className="table borderless">
                                                <thead></thead>
                                                <tbody>
                                                    {closedActionCount > 0 ?
                                                        <tr key={uuid()}>
                                                            <td>

                                                                <label className="lable-sm-upper float-end">Show Closed Actions ({closedActionCount})</label>
                                                                <input className="float-end closeCheckbox" type="checkbox" checked={isClosedActionShow} onChange={handleClosedActionShow}></input>

                                                            </td>
                                                        </tr>
                                                        : ''}
                                                    {
                                                        nutrients.actions != undefined && nutrients.actions.length != 0 ?

                                                            <tr className="actions-table" key={uuid()}>
                                                                <td >
                                                                    <Table className='table borderless '>
                                                                        <thead >
                                                                            <tr>
                                                                                <th> # </th>
                                                                                <th style={{ textAlign: 'center' }}> Category </th>
                                                                                <th style={{ width: '10%' }}> Due </th>
                                                                                <th style={{ width: '20%' }}> Risk </th>
                                                                                <th style={{ width: '20%' }}> Title  </th>
                                                                                <th style={{ width: '30%' }}> Details </th>
                                                                                <th></th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                nutrients.actions.map(action =>

                                                                                    <tr key={action.id} className={"" + (action.isCloseout === true ? "closedAction" : "openAction") + " " + (!isClosedActionShow && action.isCloseout === true ? "closed-hidden" : "")}>
                                                                                        <td> {action.id} </td>
                                                                                        <th scope="row" style={{ textAlign: 'center' }}>{action.category == null ? "" : <Badge color="danger">{action.category}</Badge>}  </th>
                                                                                        <td> {action.actionType == 46 ? "Ongoing / Management" : Moment(action.dueDate).format('DD/MM/YYYY')} </td>
                                                                                        <td> {action.riskName} </td>
                                                                                        <td> {action.title} </td>
                                                                                        <td> {action.description} </td>
                                                                                        <td>  {action.isCloseout !== true ?
                                                                                            <Button color="warning" size="sm" onClick={(e) => handleOpenAction(e, action)} > Edit </Button> :
                                                                                            <Button color="primary" size="sm" onClick={(e) => handleOpenAction(e, action)} > View </Button>}
                                                                                        </td>
                                                                                    </tr>
                                                                                )}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>
                                                            </tr>
                                                            :
                                                            <tr key={uuid()} className="actions-table"><td></td></tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Collapse>
                            
                        </Card>
                        {show_HistoricalActions &&  
                            <HistoricalActions sectionId={sectionObj.id} open={false} showArrow={true}></HistoricalActions>    
                        }
                        <Documents refid={farmId} uploadType="Nutrients" open={false} showArrow={true}></Documents>
                        {
                            sectionObj.isFarmAPTActionsReq && <ActionsToConsider sectionId={sectionObj.id} />
                        }
                        <Card className="my-4">
                            <h5 className="card-header d-flex justify-content-between align-items-center">Summary Data
                                {(roleName == 'Admin' || isAddEditItem == 'true') &&
                               <>
                                {savingNutrientDetails ?
                                    <Button style={{ float: "right" }} onClick={handleNutrientDetailsSubmit}
                                        color="success"
                                        disabled
                                    >
                                        <Row>
                                            <Col sm="8">
                                                <span>
                                                    {' '}Saving
                                                </span>
                                            </Col>
                                            <Col sm="4">
                                                <Spinner size="sm">
                                                    Saving...
                                                </Spinner>
                                            </Col>
                                        </Row>
                                    </Button>
                                    :
                                    <Button style={{ float: "right" }} onClick={handleNutrientDetailsSubmit} color="success" size="sm">
                                        Save
                                    </Button>
                                }
                                    </>
                                }
                            </h5>
                            <br />
                            <CardBody>
                                <Row>
                                    <Col>
                                        {nutrientSeasonList != undefined && nutrientSeasonList.length != 0 &&
                                            <div>
                                                <Nav tabs>
                                                    <NavItem>
                                                        <NavLink className={activeTab == '1' ? 'active' : ''} onClick={() => setActiveTab('1')}>
                                                            {nutrientSeasonList != undefined && nutrientSeasonList[0]}
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink className={activeTab == '2' ? 'active' : ''} onClick={() => setActiveTab('2')}>
                                                            {nutrientSeasonList != undefined && nutrientSeasonList[1]}
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink className={activeTab == '3' ? 'active' : ''} onClick={() => setActiveTab('3')}>
                                                            {nutrientSeasonList != undefined && nutrientSeasonList[2]}
                                                        </NavLink>
                                                    </NavItem>
                                                </Nav>
                                                <TabContent activeTab={activeTab}>
                                                    <br />
                                                    <TabPane tabId="1">
                                                        <Row>
                                                            <Col>
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Provide detail of system, version, and date where this data has been sourced from:</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeasonMinus2", "systemDetail")} type="textarea" value={seasonData.CurrentSeasonMinus2.systemDetail} disabled={false} name="systemDetail" id="systemDetail" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Nitrogen Total loss kg/yr</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeasonMinus2", "nitrogen_Total_loss")} type="number" step="0.1" min='0' value={seasonData.CurrentSeasonMinus2.nitrogen_Total_loss} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Phosphorous Total loss kg/yr</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeasonMinus2", "phosphorous_Total_loss")} type="number" step="0.1" min='0' value={seasonData.CurrentSeasonMinus2.phosphorous_Total_loss} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Nitrogen Load loss kg/ha/yr</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeasonMinus2", "nitrogen_Load_loss")} type="number" step="0.1" min='0' value={seasonData.CurrentSeasonMinus2.nitrogen_Load_loss} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Phosphorous Load loss kg/ha/yr</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeasonMinus2", "phosphorous_Load_loss")} type="number" step="0.1" min='0' value={seasonData.CurrentSeasonMinus2.phosphorous_Load_loss} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Nitrogen Conversion Efficiency %</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeasonMinus2", "nitrogen_Conversion_Efficiency_Per")} type="number" step="0.1" min='0' value={seasonData.CurrentSeasonMinus2.nitrogen_Conversion_Efficiency_Per} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">N Purchased Surplus</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeasonMinus2", "n_Purchased_Surplus")} type="number" step="0.1" min='0' value={seasonData.CurrentSeasonMinus2.n_Purchased_Surplus} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </TabPane>
                                                    <TabPane tabId="2">
                                                        <Row>
                                                            <Col>
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Provide detail of system, version, and date where this data has been sourced from:</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeasonMinus1", "systemDetail")} type="textarea" value={seasonData.CurrentSeasonMinus1.systemDetail} disabled={false} name="systemDetail" id="systemDetail" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Nitrogen Total loss kg/yr</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeasonMinus1", "nitrogen_Total_loss")} type="number" step="0.1" min='0' value={seasonData.CurrentSeasonMinus1.nitrogen_Total_loss} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Phosphorous Total loss kg/yr</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeasonMinus1", "phosphorous_Total_loss")} type="number" step="0.1" min='0' value={seasonData.CurrentSeasonMinus1.phosphorous_Total_loss} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Nitrogen Load loss kg/ha/yr</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeasonMinus1", "nitrogen_Load_loss")} type="number" step="0.1" min='0' value={seasonData.CurrentSeasonMinus1.nitrogen_Load_loss} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Phosphorous Load loss kg/ha/yr</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeasonMinus1", "phosphorous_Load_loss")} type="number" step="0.1" min='0' value={seasonData.CurrentSeasonMinus1.phosphorous_Load_loss} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Nitrogen Conversion Efficiency %</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeasonMinus1", "nitrogen_Conversion_Efficiency_Per")} type="number" step="0.1" min='0' value={seasonData.CurrentSeasonMinus1.nitrogen_Conversion_Efficiency_Per} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">N Purchased Surplus</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeasonMinus1", "n_Purchased_Surplus")} type="number" step="0.1" min='0' value={seasonData.CurrentSeasonMinus1.n_Purchased_Surplus} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </TabPane>
                                                    <TabPane tabId="3">
                                                        <Row>
                                                            <Col>
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Provide detail of system, version, and date where this data has been sourced from:</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeason", "systemDetail")} type="textarea" value={seasonData.CurrentSeason.systemDetail} disabled={false} name="systemDetail" id="systemDetail" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Nitrogen Total loss kg/yr</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeason", "nitrogen_Total_loss")} type="number" step="0.1" min='0' value={seasonData.CurrentSeason.nitrogen_Total_loss} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Phosphorous Total loss kg/yr</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeason", "phosphorous_Total_loss")} type="number" step="0.1" min='0' value={seasonData.CurrentSeason.phosphorous_Total_loss} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Nitrogen Load loss kg/ha/yr</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeason", "nitrogen_Load_loss")} type="number" step="0.1" min='0' value={seasonData.CurrentSeason.nitrogen_Load_loss} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Phosphorous Load loss kg/ha/yr</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeason", "phosphorous_Load_loss")} type="number" step="0.1" min='0' value={seasonData.CurrentSeason.phosphorous_Load_loss} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">Nitrogen Conversion Efficiency %</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeason", "nitrogen_Conversion_Efficiency_Per")} type="number" step="0.1" min='0' value={seasonData.CurrentSeason.nitrogen_Conversion_Efficiency_Per} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col sm="6">
                                                                <FormGroup>
                                                                    <Label className="label" for="name">N Purchased Surplus</Label>
                                                                    <Input onChange={(e) => seasonDataChange(e, "CurrentSeason", "n_Purchased_Surplus")} type="number" step="0.1" min='0' value={seasonData.CurrentSeason.n_Purchased_Surplus} disabled={false} name="newsItemName" id="newsItemName" autoComplete="new-password" />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </TabPane>
                                                </TabContent>
                                            </div>

                                        }
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>

                </Row>
            }
            <Modal size="lg" isOpen={nutrientPopup.showNutrientPopup} backdrop={false} className="nutrientPopup">
                <Form>
                    <ModalHeader toggle={handleNutrientPopupClose} >Add Soil Test Trip</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>LU</Label>
                                    {largeEnterpriseDetails.LMUList != undefined && largeEnterpriseDetails.LMUList != null &&
                                        <Input type="select" className="float-end validate" disabled={lmustyle} onChange={handleNutrientItemsChange} name="LMUId" id="LMUId" value={nutrientPopup.LMUId}>
                                            <option key={uuid()} value={0} >Select LU</option>
                                            {LMUParentList.map(Option =>
                                                <>
                                                    <option key={uuid()} key={Option.id} value={Option.id} className="option-parent">{Option.name}</option>
                                                    {
                                                        largeEnterpriseDetails.LMUList.filter(child => child.lmuId == Option.id).map(ChildOption =>
                                                            <option key={uuid()} key={ChildOption.id} value={ChildOption.id}> {"\u00a0\u00a0"} {ChildOption.name}</option>
                                                        )
                                                    }
                                                </>
                                            )}
                                        </Input>
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Name</Label>
                                    <Input type="text" className="validate" name="Name" id="Name" value={nutrientPopup.Name} onChange={handleNutrientItemsChange} required />
                                </FormGroup>
                            </Col>
                            <Col sm="2">
                                <FormGroup>
                                    <Label>Colour</Label>
                                    <Input type="color" name="color" id="color" value={nutrientPopup.color} onChange={handleNutrientItemsChange} />
                                </FormGroup>
                            </Col>
                            <MapType itemPopupMaptype={nutrientPopupMaptype}></MapType>
                        </Row>
                        <Row style={{ display: `none` }}>
                            <Col>
                                <FormGroup>
                                    <Label>Description</Label>
                                    <Input type="textarea" name="Description" id="Description" value={nutrientPopup.Description} onChange={handleNutrientItemsChange} required />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Date</Label>
                                    <DatePicker style={{ width: `100%` }} className="form-control"
                                        selected={nutrientPopup.date} onChange={(date1) => setNutrientPopup({ ...nutrientPopup, date: date1, dateText: getParsedDate(date1) })}
                                        name="date" id="date"
                                        dateFormat="dd/MM/yyyy"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Optimal Olsen P Range</Label>
                                    <Input type="text" name="optimalRange" id="optimalRange" value={nutrientPopup.optimalRange} onChange={handleNutrientItemsChange} required />
                                </FormGroup>
                            </Col>
                            <Col sm="6">
                                <FormGroup>
                                    <Label>Latest OLSEN P Value Range</Label>
                                    <Input type="text" name="olsenpValueRange" id="olsenpValueRange" value={nutrientPopup.olsenpValueRange} onChange={handleNutrientItemsChange} required />
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <div>
                            {nutrientPopup.id !== 0 &&
                                <>
                                {itemDeletesaving ?
                                    <>
                                        < Button onClick={(id) => deleteItembyId(nutrientPopup.id)} color="danger" disabled>
                                            <Row>
                                                <Col sm="6">
                                                    <span>
                                                        {' '}Saving
                                                    </span>
                                                </Col>
                                                <Col sm="6">
                                                    <Spinner size="sm">
                                                        Saving...
                                                    </Spinner>
                                                </Col>
                                            </Row></Button>{' '}
                                    </>
                                    :
                                    <>
                                        <Button onClick={(id) => deleteItembyId(nutrientPopup.id)} color="danger">
                                            Archive
                                        </Button>{' '}
                                    </>
                                }</>}{' '}
                            {saving ?
                                <>
                                    <Button onClick={handleNutrientSubmit} id="saveCropArea" color="success" disabled size="sm">
                                        <Row>
                                            <Col sm="6">
                                                <span>
                                                    {' '}Saving
                                                </span>
                                            </Col>
                                            <Col sm="6">
                                                <Spinner size="sm">
                                                    Saving...
                                                </Spinner>
                                            </Col>
                                        </Row></Button>{' '}
                                </>
                                :
                                <>
                                    <Button color="success" id="saveCropArea" onClick={handleNutrientSubmit} size="sm">Save</Button>{' '}
                                </>
                            }
                            <Button color="primary" onClick={handleNutrientPopupClose} size="sm">Cancel</Button>
                        </div>
                    </ModalFooter>
                </Form>
            </Modal>

            <Modal isOpen={nutrientDeletePopup.showNutrientDeletePopup}>
                <ModalHeader toggle={handleItemDeletePopupClose} >Delete the item</ModalHeader>
                <ModalBody>
                    Do you want to delete the item ?
                </ModalBody>
                <ModalFooter>
                    {itemDeletesaving ?
                        <>
                            <Button onClick={deleteItem} color="primary" disabled>
                                <Row>
                                    <Col sm="6">
                                        <span>
                                            {' '}Saving
                                        </span>
                                    </Col>
                                    <Col sm="6">
                                        <Spinner size="sm">
                                            Saving...
                                        </Spinner>
                                    </Col>
                                </Row></Button>{' '}
                        </>
                        :
                        <>
                            <Button onClick={deleteItem} color="primary">
                                Yes
                            </Button>{' '}
                        </>
                    }
                    <Button color="danger" onClick={handleItemDeletePopupClose}>No</Button>
                </ModalFooter>
            </Modal>

            {showActionPopup && <Action itemList={[]} isGHGNutrient={true} selectedLUId={0} redirectPage="/nutrients" handleActionClose={handleActionClose} itemTypeId={nutrients.itemTypes[0].id} sectionName="Nutrients" sectionId={nutrients.itemTypes[0].sectionId} itemId={nutrients.farmCenter.itemId} itemName={nutrients.farmCenter.name}
                showActionPopupModal={showActionPopup} actionId={id} itemTypeSelect={nutrients.itemTypes} itemTypeDisabled={true}></Action>}

            {riskSummaryPopup.showriskSummary && <RiskSummary section={nutrients.SectionObj} sectionId={nutrients.itemTypes[0].sectionId} riskSummaryPopup={riskSummaryPopup} handleRiskSummaryClose={handleRiskSummaryClose}></RiskSummary>}

        </div>
    )
}

export default Nutrients;